<template>
    <FilterBuilderRow
        v-if="active"
        v-bind="rowProps()"
        @remove="remove"
    >
        <template #tooltip>
            <slot name="tooltip">{{ tooltipText }}</slot>
        </template>

        <!-- Com máscara (requer a diretiva v-mask registrada globalmente, como no seu projeto) -->
        <el-input
            v-if="mask"
            v-model="draft"
            v-mask="mask"
            :disabled="disabled"
            size="small"
            clearable
            :placeholder="placeholder"
            :maxlength="maxlength"
            @keyup.enter.native.prevent="filterBuilder && filterBuilder.apply()"
        />

        <el-input
            v-else
            v-model="draft"
            :disabled="disabled"
            size="small"
            clearable
            :placeholder="placeholder"
            :maxlength="maxlength"
            @keyup.enter.native.prevent="filterBuilder && filterBuilder.apply()"
        />
    </FilterBuilderRow>
</template>

<script>
    import { Input } from 'element-ui';
    import FilterBuilderRow from './FilterBuilderRow.vue';
    import filterBuilderItem from './filterBuilderItem';

    export default {
        name: 'FilterBuilderInput',
        mixins: [filterBuilderItem],
        props: {
            placeholder: { type: String, default: 'Digite um valor' },
            mask: { type: [String, Array], default: null }, // ex.: ['###.###.###-##']
            maxlength: { type: [String, Number], default: null },
        },
        methods: {
            getEmptyValue() {
                return '';
            },
        },
        components: {
            FilterBuilderRow,
            [Input.name]: Input,
        },
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/FilterBuilder/FilterBuilderInput.vue